import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import AcceptLeadModal from '../components/accept-lead-modal';
import closeSmallModal from '../actions/CloseSmallModal';

const SmallModal = (props) => {
    const closeSmallModalFn = (event) => {
        event.stopPropagation();
        props.closeSmallModal();
    };

    if (!props.smallModal.open) {
        return <div />;
    }

    let content = <div />;
    switch (props.smallModal.type) {
        case 'ACCEPT_LEAD':
            content = <AcceptLeadModal lead={props.smallModal.data} />;
            break;
        default:
            content = <div />;
    }

    return (
        <div>
            <div
                className="small-modal-container"
                onClick={closeSmallModalFn}
                onKeyPress={closeSmallModalFn}
                tabIndex="0"
                role="button"
                aria-label="Close"
            />
            <div className="small-modal" onClick={(e) => e.stopPropagation()}>
                <div className="small-modal-header">
                    <button
                        type="button"
                        className="close pull-right"
                        aria-label="Close"
                        onClick={closeSmallModalFn}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                {content}
            </div>
        </div>
    );
};

SmallModal.propTypes = {
    smallModal: PropTypes.object.isRequired,
    closeSmallModal: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
    smallModal: state.smallModal,
});

const mapDispatchToProps = dispatch => ({
    closeSmallModal: () => dispatch(closeSmallModal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(SmallModal);
